import { RootDispatch } from "../types";
import history from "../../history";
import { post } from "../../utils/fetch";
import { SESSION_FETCHED_CURRENT_USER, useEmbedTheme } from "../session/actions";

export type Action =
  | { type: "psMobileTestPage/registerByAccessToken-started" }
  | { type: "psMobileTestPage/registerByAccessToken-success" }
  | { type: "psMobileTestPage/registerByAccessToken-failure"; errorMessage: string };

export const registerByAccessToken = (token: string, backend: string) => async (
  dispatch: RootDispatch
) => {
  dispatch({
    type: "psMobileTestPage/registerByAccessToken-started"
  });

  const url = `/api/oauth2/register/${backend}/`;
  const body = { accessToken: token };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const resp = await post<any>(url, body);

  if (resp.error) {
    dispatch({
      type: "psMobileTestPage/registerByAccessToken-failure",
      errorMessage: resp.error.message
    });
  } else if (resp.data) {
    dispatch({ type: "psMobileTestPage/registerByAccessToken-success" });
    dispatch({ type: SESSION_FETCHED_CURRENT_USER, user: resp.data });
    dispatch(useEmbedTheme());
    history.push(`/dashboard/`);
  } else {
    // TODO Logging
  }
};
